import { render } from "./end-detail.vue?vue&type=template&id=d9b1bea6"
import script from "./end-detail.vue?vue&type=script&lang=js"
export * from "./end-detail.vue?vue&type=script&lang=js"

import "./end-detail.vue?vue&type=style&index=0&id=d9b1bea6&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__